import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  data2 as data2Selector,
  data as dataSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { graphPensionsSelector } from './PensionsOverviewSelector';
import { BACKEND_KEY } from '../PensionWorkflowConstants';
import { isUuid, isNumeric } from '../../../../js/app/react/validators';

export const pensionIDSelector = createSelector(data2Selector, (data2) => {
  const pensionID = data2(`${BACKEND_KEY}.PensionStepID`);
  if (isUuid(pensionID)) {
    return pensionID;
  }
  return null;
});

export const pensionSelector = createSelector(
  graphPensionsSelector,
  pensionIDSelector,
  (graphPensions, pensionID) => {
    if (pensionID === null) {
      throw new Error('pensionSelector: pensionID was not set');
    }
    const pension = graphPensions.find(({ Id, frontEndId }) => (Id || frontEndId) === pensionID);

    if (!pension) {
      throw new Error('pensionSelector: pensionID was not found in the pension list');
    }
    return pension;
  },
);

export const isEditSelector = createSelector(
  data2Selector,
  data2 => !!data2(`${BACKEND_KEY}.PensionStepIsEdit`),
);

export const ownersOptionsSelector = createSelector(dataSelector, data =>
  (data('PensionOwners') || []).map(firstName => ({ label: firstName, value: firstName })));
export const typesOptionsSelector = createSelector(
  dataSelector,
  data => data('PensionTypes') || [],
);
export const agesOptionsSelector = createSelector(dataSelector, (data) => {
  let options = data('PensionDistributionAgeOptions') || [];
  const personalInfoOrDefault = data('PersonalInfo') || {};

  const currentPrincipalAge = get(personalInfoOrDefault || {}, 'Principal.Age', null);
  const currentSpouseAge = get(personalInfoOrDefault || {}, 'Partner.Age', null);
  let minAge = currentPrincipalAge;

  if (isNumeric(currentSpouseAge)) {
    minAge = currentSpouseAge;
  }

  if (isNumeric(minAge)) {
    options = options.filter(value => value >= minAge);
  }
  return [
    {
      label: 'At Retirement',
      value: -1,
    },
  ].concat(options.map(option => ({ label: option.toString(), value: option })));
});
